import { useEffect, useState } from "react";
import classes from "./styles.module.scss";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logoutUser } from "src/redux/slices/exerciseSlice";

export const WalkyLayout = ({ children, title }) => {
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();

  const toggleBurger = () => {
    setOpen(!open);
    document.body.classList.toggle("scroll-lock");
  };

  const handleOpenProfileSettings = () => {
    toggleBurger();
  };

  const handleLogOut = () => {
    localStorage.removeItem("token");
    window.location = "/auth";
    toggleBurger();
  };

  return (
    <div className={classes.container}>
      <header className={classes.header}>
        <p>{title}</p>
        <div
          className={
            open ? `${classes.burger} ${classes.open}` : `${classes.burger}`
          }
          onClick={toggleBurger}
        >
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </header>
      <div
        className={open ? `${classes.menu} ${classes.open}` : `${classes.menu}`}
      >
        <h5 className={classes.menuTitle}>Menu</h5>
        <nav>
          <ul>
            <li>
              <Link onClick={handleOpenProfileSettings}>App</Link>
            </li>
            <li>
              <Link onClick={handleLogOut}>Log out</Link>
            </li>
          </ul>
        </nav>
      </div>
      <div className={classes.children}>{children}</div>
    </div>
  );
};
